import http from 'services/http';

// One row per browser/device the user has enabled push on; the API never
// returns the browser's keys, only the endpoint the page matches this device against.
export type PushSubscriptionRow = {
  id: string;
  endpoint: string;
  userAgent: string | null;
  lastUsedAt: string | null;
  failedAt: string | null;
  createdAt: string;
};

export type PushSubscriptionsIndex = {
  // The VAPID public key as PushManager.subscribe takes it (base64url, no padding); null when the
  // environment has no usable keypair — the page cannot subscribe then.
  meta: { vapidPublicKey: string | null };
  data: PushSubscriptionRow[];
};

// The browser's PushSubscription.toJSON() shape plus the user agent, so the devices list can name
// the browser. OliveBranch snake-cases the keys on the way in.
export type CreatePushSubscriptionParams = {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  userAgent: string;
};

export const pushSubscriptionQueryKeys = {
  index: () => ['pushSubscriptions', 'index'] as const,
  // This browser's own PushSubscription, read from the service worker registration — not an API
  // call, but the same cache so the hook and its mutations have one source of truth for it.
  browser: () => ['pushSubscriptions', 'browser'] as const,
};

export async function indexPushSubscriptions() {
  return http.get<PushSubscriptionsIndex>('push_subscriptions').then((res) => res.data);
}

export async function createPushSubscription(params: CreatePushSubscriptionParams) {
  return http.post<PushSubscriptionRow>('push_subscriptions', params).then((res) => res.data);
}

export async function destroyPushSubscription(id: string) {
  return http.delete(`push_subscriptions/${id}`).then(() => id);
}
